import Layout from '@/app/component/layout/page'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import VerifyRecoveryCodeForm from '@/app/module/auth/component/verify-recovery-code'
import Notifications from '@/app/module/notifications'

export default function VerifyRecoveryCodePage(props: any) {
  const { name, match } = props
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Two-factor recovery - engageSPARK">
        <AuthHeader currentPage={name} />
        <VerifyRecoveryCodeForm />
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
